<script>
  import CloseIcon from '$lib/assets/icons/CloseIcon.svelte';
  import { VIDEO_NOT_FOUND_MESSAGE } from '$lib/constants/text';

  export let showModal = false;
</script>

<div class="video-not-found-container">
  <button class="icon-wrapper" on:click={() => (showModal = false)}>
    <CloseIcon />
  </button>

  <div class="video-not-found">
    <h3>{VIDEO_NOT_FOUND_MESSAGE}</h3>
  </div>
</div>

<style>
  .video-not-found {
    color: var(--color-text-light);
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-light);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon-wrapper {
    position: absolute;
    top: 15px;
    right: 15px;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    padding: 8px;
    display: flex;
    border: none;
    justify-content: center;
    align-items: center;
    background-color: var(--color-page-background);
    cursor: pointer;
  }
</style>
